export const iconFontAwesomeHandsHandHoldingHand = (
	<i className="fa-solid fa-hand-holding-hand"></i>
);
